// extracted by mini-css-extract-plugin
module.exports = {"content":"AdminSaleOfferTypeColumn_content__jHgAd","tag":"AdminSaleOfferTypeColumn_tag__HKnJh","tag2":"AdminSaleOfferTypeColumn_tag2__GZ4rg"};